export default __webpack_public_path__ + "static/media/portfolio-picture.9e4bfc47.jpg";